import {ClientTypes, ProductTag} from '@/libs/constants/common.constants';

export const parseProductsToCart = (cartProducts) => {
	const ids = [];
	const productStore = {};
	for (let i = 0; i < cartProducts.length; i++) {
		ids.push(cartProducts[i].product.id);
		productStore[cartProducts[i].product.id] = cartProducts[i].quantity;
	}
	return {
		ids,
		productStore
	}
}

export const parseFreshCartProducts = (cart, productStore, clientType) => {
	const freshData = [];
	let totalPrice = 0;
	let quantity = 0;
	
	for (let i = 0; i < cart.length; i++) {
		const res = cart[i];
		
		if (res.prices.length !== 1) break;
		const price = structuredClone(res.prices[0]);
		
		if (res.discount > 0 && res.tag === ProductTag.SALE) {
			price.priceComputed = price.price - price.price * res.discount;
			price.overpriceComputed = price.price;
			price.crossed = true;
		} else {
			price.priceComputed = price.price;
			price.overpriceComputed = price.overprice;
		}
		
		totalPrice += (clientType === ClientTypes.WHOLESALER && price.wholesalePrice != null ? price.wholesalePrice : price.priceComputed) * productStore[res.id];
		quantity += productStore[res.id];
		
		freshData.push({
			product: {
				id: res.id,
				alt: res.alt,
				title: res.title,
				coverImage: res.coverImage,
				price
			},
			quantity: productStore[res.id]
		});
	}
	return {
		freshData,
		totalPrice,
		quantity
	};
}

export const parseFreshWishlistProducts = (wishlist) => {
	const freshData = [];
	
	for (let i = 0; i < wishlist.length; i++) {
		const res = wishlist[i];
		
		if (res.prices.length !== 1) break;
		const price = structuredClone(res.prices[0]);
		
		if (res.discount > 0 && res.tag === ProductTag.SALE) {
			price.priceComputed = price.price - price.price * res.discount;
			price.overpriceComputed = price.price;
			price.crossed = true;
		} else {
			price.priceComputed = price.price;
			price.overpriceComputed = price.overprice;
		}
		
		freshData.push({
			product: {
				id: res.id,
				alt: res.alt,
				title: res.title,
				coverImage: res.coverImage,
				price
			}
		});
	}
	return {
		freshData
	};
}

export const parseCartProducts = (clientCart = [], clientType, isCheckout = false) => {
	const freshData = [];
	let totalPrice = {
		common: 0,
		sale: 0
	};
	
	for (let i = 0; i < clientCart.length; i++) {
		const cart = clientCart[i];
		
		if (cart.product.prices.length !== 1) break;
		const price = structuredClone(cart.product.prices[0]);
		
		if (cart.product.discount > 0 && cart.product.tag === ProductTag.SALE) {
			price.priceComputed = price.price - price.price * cart.product.discount;
			price.overpriceComputed = price.price;
			price.crossed = true;
		} else {
			price.priceComputed = price.price;
			price.overpriceComputed = price.overprice;
		}
		
		if ((cart.product.discount > 0 && cart.product.tag === ProductTag.SALE) || (clientType === ClientTypes.WHOLESALER && price.wholesalePrice != null)) {
			totalPrice.sale += (clientType === ClientTypes.WHOLESALER && price.wholesalePrice != null ? price.wholesalePrice : price.priceComputed) * cart.quantity;
		} else {
			totalPrice.common += price.priceComputed * cart.quantity;
		}
		
		freshData.push({
			product: {
				id: cart.product.id,
				alt: cart.product.alt,
				title: cart.product.title,
				status: cart.product.status,
				quantity: cart.product.quantity,
				coverImage: cart.product.coverImage,
				tag: cart.product.tag,
				discount: cart.product.discount,
				price
			},
			quantity: cart.quantity
		});
	}
	return {
		freshData,
		totalPrice: isCheckout ? totalPrice : (totalPrice.sale + totalPrice.common)
	};
}

export const getActualPricePolicy = (policy, price) => {
	if (policy.length === 1) {
		return {
			fromPrice: policy[0].fromPrice,
			discount: policy[0].discount,
			toPrice: null,
		};
	}
	
	if (price < policy[0].fromPrice) {
		return { fromPrice: 0, toPrice: policy[0].fromPrice, discount: 0 };
	}
	
	let left = 0;
	let right = policy.length - 1;
	let result = { fromPrice: 0, toPrice: null, discount: 0 };
	
	while (left <= right) {
		const mid = Math.floor((left + right) / 2);
		
		if (policy[mid].fromPrice <= price) {
			result = {
				fromPrice: policy[mid].fromPrice,
				toPrice: policy[mid + 1] ? policy[mid + 1].fromPrice : null,
				discount: policy[mid].discount,
			};
			left = mid + 1;
		} else {
			right = mid - 1;
		}
	}
	
	return result;
};

export const parseWishlistProducts = (clientWishlist = []) => {
	const freshData = [];
	
	for (let i = 0; i < clientWishlist.length; i++) {
		const wishlist = clientWishlist[i];
		
		if (wishlist.product.prices.length !== 1) break;
		const price = structuredClone(wishlist.product.prices[0]);
		
		if (wishlist.product.discount > 0 && wishlist.product.tag === ProductTag.SALE) {
			price.priceComputed = price.price - price.price * wishlist.product.discount;
			price.overpriceComputed = price.price;
			price.crossed = true;
		} else {
			price.priceComputed = price.price;
			price.overpriceComputed = price.overprice;
		}
		
		freshData.push({
			product: {
				id: wishlist.product.id,
				alt: wishlist.product.alt,
				title: wishlist.product.title,
				status: wishlist.product.status,
				quantity: wishlist.product.quantity,
				coverImage: wishlist.product.coverImage,
				price
			}
		});
	}
	return {
		freshData
	};
}
